"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = getQueryString;
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.constructor");
/**
 * 使用正则获取URL参数（兼容性好）
 * @param {string} name - 参数名
 * @returns {string|null}
 */
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}